import {inject, Injectable} from '@angular/core';
import {
  GetSelectDataParams,
  RecordUpdateRequestParams,
  SelectData
} from "../../../../../../../core/types/records-table.types";
import {BaseKeyTestData, KeyTestData, SetBaseKeyTestDataParams} from "../types/key-tests-modal.types";
import {KeyTestsApiService} from "../services-api/key-tests-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {
  defaultRecordsDataRequestQueryParams
} from "../../../../../../../core/models/default-records-data-request-query-params";
import {UtilityService} from "../../../../../../../core/services/utility.service";

@Injectable({
  providedIn: 'root'
})
export class KeyTestsService {
  private keyTestsApiService: KeyTestsApiService = inject(KeyTestsApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private utilityService: UtilityService = inject(UtilityService);

  public setBaseKeyTestData({ keyTestForm, noteId }: SetBaseKeyTestDataParams): BaseKeyTestData {
    const date = keyTestForm.get('date')?.value;
    const formattedDate = date ? this.utilityService.formatDateToRussianStyle(date) : null;
    const value = keyTestForm.get('time')?.value;
    const formattedTime = value ? this.utilityService.dateToTimeString(new Date(value)) : null;

    return {
      noteId: noteId,
      ...keyTestForm.value,
      time: formattedTime,
      date: formattedDate
    };
  }

  public fetchKeyTestsData(noteId: number): Promise<Array<KeyTestData>> {
    const queryParams = {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      noteId: noteId
    };

    return new Promise((resolve, reject) => {
      this.keyTestsApiService.fetchKeyTestSData(queryParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public createKeyTestData(baseKeyTestData: BaseKeyTestData): Promise<KeyTestData> {
    return new Promise((resolve, reject) => {
      this.keyTestsApiService.createKeyTestData(baseKeyTestData).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updateKeyTestField(updateRecordParams: RecordUpdateRequestParams): Promise<KeyTestData> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<KeyTestData>(updateRecordParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
